const listAttributes = [
  'requestId',
  'creationDatetime',
  'dueDatetime',
  'examSubject',
  'examId',
  'examLabel',
  'fileName',
  'marker',
  'markerName',
  'status',
  'student',
  'studentName',
] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = [
  'examSubject',
  'examId',
  'examLabel',
  'marker',
  'markerName',
  'student',
  'studentName',
  'dueDatetime',
  'status',
] as const;

export const LegacyExamMarkingRequestAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

export const MAX_LEGACY_EXAM_SCAN_UPLOADS = 50;
